import React, { Component, Suspense, lazy } from 'react';
import './scss/style.scss';
import '../src/assets/css/custom-styles.css';
import '../src/assets/css/styles.css';
import '../src/assets/css/framework.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { OidcProvider } from 'redux-oidc';
import store from 'src/store/index';
import { userManager } from './authentication';
import { Provider, connect } from 'react-redux';
import { getAdminDetails, getIpRegisteryData } from './reducers/authReducer';
import UserActivityLogsGrid from './components/userActivityLogs';
import EnergyDashBoard from './components/energy';
const DefaultLayout = lazy(() => import('./layout/DefaultLayout'));
const CallbackPage = lazy(() => import('./authentication/callback.components'));
const AccessDenied = lazy(() => import('./components/toolbar.component/accessDenied'));
const TenantGrid = lazy(() => import('./components/tenantgrid'));
const AllCards = lazy(() => import('./components/SelectCards'));
const ProgramDetails = lazy(() => import('./components/shared/program.details'));
const Tenantview = lazy(() => import('./components/tenantgrid/tenantview'));
const AccountOverview = lazy(() => import('./components/portfolio'));
const Portfolio = lazy(() => import('./components/portfolio/portfolio'));
const ActivityLog = lazy(() => import('./components/activitylog'));
const CardOverView = lazy(() => import('./components/cards'));
const CardDetails = lazy(() => import('./components/cards/cardDetails/index'));
const CardTransactions = lazy(() => import('./components/transactions'));
const CreateCase = lazy(() => import('./components/transactions/cases/createCase'));
const CardOperations = lazy(() => import('./components/cardOperations'));
const CardOperationsDetails = lazy(() => import('./components/cardOperations/operationDetails'));
const DeveloperConfig = lazy(() => import('./components/DeveloperConfig'));
const Transfers = lazy(() => import('./components/Transfers'));
const TopUp = lazy(() => import('./components/TopUp'));
const Programs = lazy(() => import('./components/programs'));
const Cases = lazy(() => import('./components/cases'));
const ViewCases = lazy(() => import('./components/cases/casesView'));
const Edit = lazy(() => import('./components/cases/case/edit'));
const KybInfo = lazy(() => import('./components/kyb'));
const CardsAll = lazy(() => import('./components/allCards'));
const CardAction = lazy(() => import('./components/allCards/cardAction'));
const ErrorComponent = lazy(() => import('./components/shared/errorComponent'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      { path: 'callback', element: <CallbackPage />, errorElement: <ErrorComponent /> },
      { path: 'accessdenied', element: <AccessDenied />, errorElement: <ErrorComponent /> },
      { path: 'partners', element: <TenantGrid />, errorElement: <ErrorComponent /> },
      { path: 'partners/tenantCards/:id/:name', element: <AllCards />, errorElement: <ErrorComponent /> },
      {
        path: 'partners/tenantCards/:tenantId/:tenantName/:tabName?/cardDetails/:cardId?/:name?',
        element: <ProgramDetails />,
        errorElement: <ErrorComponent />
      },
      {
        path: 'partners/viewtenant/:tenantId?/:tenantName?',
        element: <Tenantview />,
        errorElement: <ErrorComponent />,
        children: [
          {
            path: 'accountOverview',
            element: <AccountOverview />,
            errorElement: <ErrorComponent />,
            children: [
              { path: 'Portfolio', element: <Portfolio />, errorElement: <ErrorComponent /> },
              { path: 'activitylog', element: <ActivityLog />, errorElement: <ErrorComponent /> },
            ]
          },
          { path: 'cards', element: <CardOverView />, errorElement: <ErrorComponent /> },
          { path: 'cardOverViewDetails/:id?/:name?', element: <CardDetails />, errorElement: <ErrorComponent /> },
          { path: 'cardTransactions', element: <CardTransactions />, errorElement: <ErrorComponent /> },
          {
            path: 'cardTransactions/:txId?/transactioncreatecase',
            element: <CreateCase />,
            errorElement: <ErrorComponent />
          },
          { path: 'cardActivity', element: <CardOperations />, errorElement: <ErrorComponent /> },
          { path: 'operations', element: <ActivityLog />, errorElement: <ErrorComponent /> },
          { path: 'activitylogs', element: <UserActivityLogsGrid />, errorElement: <ErrorComponent /> },
          {
            path: 'cardOpearationDetails/:id?/:name?',
            element: <CardOperationsDetails />,
            errorElement: <ErrorComponent />
          },
          { path: 'developerconfig', element: <DeveloperConfig />, errorElement: <ErrorComponent /> },
          { path: 'transfers', element: <Transfers />, errorElement: <ErrorComponent /> },
          { path: 'topup', element: <TopUp />, errorElement: <ErrorComponent /> },
          { path: 'services', element: <Programs />, errorElement: <ErrorComponent /> },
          {
            path: 'services/cardDetails/:cardId?/:name?',
            element: <ProgramDetails />,
            errorElement: <ErrorComponent />
          },
          { path: 'cases', element: <Cases />, errorElement: <ErrorComponent /> },
          { path: 'cases/:id/:caseState?', element: <ViewCases />, errorElement: <ErrorComponent /> },
          {
            path: 'cases/edit/:id/:screen?/:caseState?',
            element: <Edit />,
            errorElement: <ErrorComponent />
          },
          { path: 'kyb', element: <KybInfo />, errorElement: <ErrorComponent /> },
          { path: 'energy', element: <EnergyDashBoard/>, errorElement: <ErrorComponent /> }
        ]
      },
      {
        path: 'cards',
        errorElement: <ErrorComponent />,
        children: [
          { path: 'allCards', element: <CardsAll />, errorElement: <ErrorComponent /> },
          { path: 'allCards/add/:id', element: <CardAction mode={'Add'} />, errorElement: <ErrorComponent /> },
          { path: 'allCards/edit/:id', element: <CardAction mode={'Edit'} />, errorElement: <ErrorComponent /> },
          { path: 'allCards/view/:id', element: <CardAction mode={'View'} />, errorElement: <ErrorComponent /> }
        ]
      }
    ]
  }
]);

class App extends Component {
  componentDidMount() {
    this.getCustomerDetails();
  }

  getCustomerDetails = async () => {
    if (this.props.user && this.props.user.profile) {
      await this.props.trackauditlogs();
      this.props.getmemeberInformation(this.props.user.profile.sub);
    }
  };

  render() {
    return (
      <Provider store={store}>
        <OidcProvider userManager={userManager} store={store}>
          <React.StrictMode>
            <Suspense>
              <RouterProvider router={router} />
            </Suspense>
          </React.StrictMode>
        </OidcProvider>
      </Provider>
    );
  }
}

const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig?.userProfileInfo, user: oidc?.user };
};

const connectDispatchToProps = (dispatch) => {
  return {
    getmemeberInformation: (useremail) => dispatch(getAdminDetails(useremail)),
    trackauditlogs: () => dispatch(getIpRegisteryData())
  };
};

export default connect(connectStateToProps, connectDispatchToProps)(App);